import { lazy } from "react";

export const LazyPreviewPage = lazy(() => import("./previewPage"));
